import { render } from "./AvatarDialog.vue?vue&type=template&id=7832d5c4"
import script from "./AvatarDialog.vue?vue&type=script&lang=js"
export * from "./AvatarDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__